export default "__VITE_ASSET__HsT_yqrL__"